import { Link } from 'react-router-dom';
import { Mail, Phone, Plane } from 'lucide-react';
import {
  COMPANY_EMAIL,
  COMPANY_NAME,
  COPYRIGHT_END,
  FOOTER_DISCLAIMER,
  PHONE,
  PHONE_RAW,
  SITE_NAME,
} from '../constants/site';
import './Footer.css';

const tel = PHONE_RAW.replace(/[^\d+]/g, '');

const LINKS = [
  { to: '/flight', label: 'Home' },
  { to: '/flight/about', label: 'About' },
  { to: '/flight/support', label: 'Contact' },
  { to: '/flight/privacy', label: 'Privacy' },
  { to: '/flight/terms', label: 'Terms' },
];

export default function Footer() {
  return (
    <footer className="site-footer site-footer--compact">
      <div className="container footer-compact">
        <div className="footer-compact__row">
          <Link to="/flight" className="footer-compact__brand">
            <Plane size={18} aria-hidden />
            <span>{SITE_NAME}</span>
          </Link>

          <nav className="footer-compact__nav" aria-label="Footer">
            {LINKS.map(({ to, label }) => (
              <Link key={to} to={to}>
                {label}
              </Link>
            ))}
          </nav>

          <div className="footer-compact__contact">
            <a href={`tel:${tel}`} className="footer-compact__phone">
              <Phone size={15} aria-hidden />
              {PHONE}
            </a>
            <a href={`mailto:${COMPANY_EMAIL}`} className="footer-compact__email">
              <Mail size={15} aria-hidden />
              {COMPANY_EMAIL}
            </a>
          </div>
        </div>

        <div className="footer-compact__disclaimer">
          {FOOTER_DISCLAIMER.map((paragraph) => (
            <p key={paragraph.slice(0, 48)}>{paragraph}</p>
          ))}
        </div>

        <p className="footer-compact__copy">
          &copy; {COPYRIGHT_END} {COMPANY_NAME}. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
